const RestURL = "https://us-central1-hume-playground.cloudfunctions.net/api/users"
const appName = "playground-app"

export { appName, RestURL};